import Vue from 'vue'
import mutations from './mutations'
import businessUnits from '../../api/businessUnits'
import { arrayToObject, objectToArray } from '@/utils/object'

import { loadItemBuilder, saveItemBuilder, deleteItemBuilder } from '../crudFactory'
const apiEndpoint = 'businessUnits'

export default {
  namespaced: true,

  state: {
    items: {},
    comments: {},
    komentarjiSkupine: {},
    currentBusinessUnit: JSON.parse(localStorage.getItem('currentBusinessUnit')) || null
  },

  getters: {
    fullName: state => id => {
      return state[id].currentBusinessUnit.name
    },
    currentFullName: state => {
      if (state.currentBusinessUnit) {
        return state.currentBusinessUnit.name
      }
      return null
    },
    companyHasMultipleBusinessUnits: state => {
      return Object.values(state.items).length > 1
    }
  },

  actions: {
    loadItems ({ commit, state }, headers) {
      return new Promise((resolve, reject) => {
        businessUnits.getAll(headers)
          .then(response => {
            if (response.data.items.length) {
              const items = arrayToObject(response.data.items)
              if (!state.currentBusinessUnit) {
                commit('setCurrent', objectToArray(items)[0])
              }
              commit('setElements', { type: 'items', elements: items })
              resolve(items)
            }
            resolve({})
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    loadItem: loadItemBuilder({ apiEndpoint }),
    loadComments ({ commit, state }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = state.currentBusinessUnit.id
        businessUnits.getComments({ businessUnitId })
          .then(response => {
            if (response.data.items.length) {
              const items = arrayToObject(response.data.items)
              commit('setElements', { type: 'comments', elements: items })
              resolve(items)
            }
            resolve({})
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    setComments ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        const businessUnitId = state.currentBusinessUnit.id
        businessUnits.setComment({ businessUnitId, data })
          .then((idComment) => {
            resolve(idComment)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    deleteComment ({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        const businessUnitId = state.currentBusinessUnit.id
        businessUnits.deleteComment({ businessUnitId, commentId: id })
          .then(() => {
            commit('removeElement', { type: 'comments', id })
            // console.log(state.comments, commentId)
            resolve()
          })
          .catch((err) => reject(err))
      })
    },
    async deleteTableSessions ({ commit, state }) {
      const businessUnitId = state.currentBusinessUnit.id
      await businessUnits.deleteTableSessions({ businessUnitId })
      return
    },
    setCommentCategory ({ state, dispatch }, { listaKategorij, commentId }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = state.currentBusinessUnit.id
        const cakat = []
        listaKategorij.map(categoryId => {
          cakat.push(businessUnits.setCommentCategory({ businessUnitId, categoryId: categoryId.id, commentId }))
        })
        Promise.all(cakat)
          .then(() => {
            dispatch('getCommentCategories', { id: commentId })
              .then((items) => {
                resolve(items)
              })
          })
          .catch(() => {
            resolve()
          })
      })
    },
    getCommentCategories ({ state, commit }, { id }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = state.currentBusinessUnit.id
        const orderCommentId = id
        businessUnits.getCommentCategories({ businessUnitId, orderCommentId })
          .then((usp) => {
            const comment = usp.data && usp.data.items ? usp.data.items : null
            const groupComment = { ...state.komentarjiSkupine }
            groupComment[id] = comment
            commit('setElements', { type: 'komentarjiSkupine', elements: groupComment })
            resolve(comment)
          })
          .catch((err) => reject(err))
      })
    },
    deleteCommentCategory ({ state, commit }, { orderCommentId, categoryId }) {
      return new Promise((resolve, reject) => {
        const businessUnitId = state.currentBusinessUnit.id
        businessUnits.deleteCommentCategory({ businessUnitId, categoryId, orderCommentId })
          .then((usp) => {
            const index = state.komentarjiSkupine[orderCommentId].findIndex(el => el.id === categoryId)
            commit('removeCommentCategory', { orderCommentId, index })
            resolve()
          })
          .catch((err) => reject(err))
      })
    },
    saveItem: saveItemBuilder({ apiEndpoint }),
    deleteItem: deleteItemBuilder({ apiEndpoint }),
    selectCurrent ({ commit }, item) {
      commit('setCurrent', item)
    },
    statusOrdering ({ state }, { businessUnitId, status, headers }) {
      return new Promise((resolve, reject) => {
        businessUnits.statusOrderingPermission({ businessUnitId, status, headers })
          .then(resp => resolve(resp))
          .catch(err => reject(err))
      })
    },
    statusTables ({ state }, { businessUnitId, status, headers }) {
      return new Promise((resolve, reject) => {
        businessUnits.statusTablesPermission({ businessUnitId, status, headers })
          .then(resp => resolve(resp))
          .catch(err => reject(err))
      })
    },
    loadBusinessUnitPricing ({ state }, pricingId = null) {
      return new Promise((resolve, reject) => {
        const businessUnitId = state.currentBusinessUnit.id
        businessUnits.getBusinessUnitPricing({ businessUnitId, pricingId })
          .then(resp => {
            resolve(resp.data && resp.data.items ? resp.data.items : [])
          })
          .catch(err => reject(err))
      })
    },
    setBusinessUnitPricingTime ({ state }, data) {
      return new Promise((resolve, reject) => {
        const businessUnitId = state.currentBusinessUnit.id
        businessUnits.setBusinessUnitPricingTime({ businessUnitId, data })
          .then(resp => {
            resolve(resp.data && resp.data.items ? resp.data.items[0] : null)
          })
          .catch(err => reject(err))
      })
    },
    deleteBusinessUnitPricing ({ state }, pricingId) {
      return new Promise((resolve, reject) => {
        const businessUnitId = state.currentBusinessUnit.id
        businessUnits.deleteBusinessUnitPricing({ businessUnitId, pricingId })
          .then(resp => resolve(resp))
          .catch(err => reject(err))
      })
    },
    setBusinessUnitPricingArticles ({ state }, data) {
      return new Promise((resolve, reject) => {
        const businessUnitId = state.currentBusinessUnit.id
        businessUnits.setBusinessUnitPricingArticles({ businessUnitId, data })
          .then(resp => resolve(resp))
          .catch(err => reject(err))
      })
    },
    enableBusinessUnitPricing ({ state }, { businessUnitId, headers }) {
      return new Promise((resolve, reject) => {
        businessUnits.enableBusinessUnitPricing({ businessUnitId, headers })
          .then(resp => resolve(resp))
          .catch(err => reject(err))
      })
    },
    disableBusinessUnitPricing ({ state }, { businessUnitId, headers }) {
      return new Promise((resolve, reject) => {
        businessUnits.disableBusinessUnitPricing({ businessUnitId, headers })
          .then(resp => resolve(resp))
          .catch(err => reject(err))
      })
    },
    setPricingAsMain ({ state }, pricingId) {
      return new Promise((resolve, reject) => {
        const businessUnitId = state.currentBusinessUnit.id
        businessUnits.setPricingAsMain({ businessUnitId, pricingId })
          .then(resp => resolve(resp))
          .catch(err => reject(err))
      })
    }
  },

  mutations: {
    ...mutations,
    setCurrent (state, item) {
      localStorage.setItem('currentBusinessUnit', JSON.stringify(item))
      Vue.set(state, 'currentBusinessUnit', item)
    },
    removeCommentCategory (state, { orderCommentId, index }) {
      Vue.delete(state.komentarjiSkupine[orderCommentId], index)
    }
  }
}
